/**
 * Returns `true` if window is currently nested within an iframe.
 */
export function isIframe(): boolean {
	return window.self !== window.top;
}
